module.exports = __webpack_public_path__ + "logo-gitlab.svg?732b7c4a29f9b0da3eefc2f678853f2c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-gitlab.svg
// module id = 391
// module chunks = 0